type Icon =
  | 'filter'
  | 'delete'
  | 'undo'
  | 'right-arrow-v'
  | 'left-arrow-v'
  | 'refresh'
  | 'edit'
  | 'close'
  | 'download'
  | 'right-arrow'
  | 'left-arrow'
  | 'sync'
  | 'overflow'
  | 'preview'
  | 'upload'
  | 'save'
  | 'settings'
  | 'redo'
  | 'today'
  | 'comments'
  | 'call'
  | 'email'
  | 'zoom-in'
  | 'zoom-out'
  | 'collapse'
  | 'expand';

type IconWithAdd = Icon | 'add';

interface Props {
  children?: JSX.Element | string | undefined;
  className?: string;
  disabled?: boolean;
  handleClick?: React.MouseEventHandler<HTMLDivElement> | undefined;
  href?: string;
  icon?: IconWithAdd;
  size?: 'default' | 'small';
  target?: string;
  type?: 'button' | 'reset' | 'submit';
  value?: string;
  variant?: 'control' | 'danger' | 'primary' | 'reverse' | 'secondary' | 'text';
}

const Button = ({
  children,
  className,
  disabled,
  handleClick,
  href,
  icon,
  size,
  target,
  type,
  value,
  variant,
}: Props) => {
  /* For some reason, the RAUL API doesn't accept an 'add' icon.
  The logic yoga here is to make the props system more intuitive for components
  trying to render the button. */
  const isAdd = icon === 'add';
  const isDelete = icon === 'delete';
  const iconIsAddDelete = isAdd || isDelete;
  const iconProp = iconIsAddDelete ? '' : icon;

  return (
    <raul-button
      // @ts-expect-error: class and children "does not exist on type"
      // eslint-disable-next-line react/no-children-prop
      children={children}
      add={isAdd}
      class={className}
      delete={isDelete}
      disabled={disabled || false}
      href={href || ''}
      icon={iconProp as Icon}
      onClick={handleClick}
      size={size || 'default'}
      target={target || ''}
      type={type || 'button'}
      value={value || ''}
      variant={variant || 'secondary'}
    />
  );
};

export default Button;
